import React, { useEffect, useState } from 'react';
import { CounterStore } from './CounterStore';
import './App.css';
var counterStore = new CounterStore();
var Counter = function () {
    var _a = useState(0), value = _a[0], setValue = _a[1];
    useEffect(function () {
        counterStore = new CounterStore();
        counterStore.getSubject().subscribe({
            next: function (v) {
                setValue(counterStore.getCounter());
                console.log("Set local state with : " + v);
            }
        });
        console.log("subscribe ");
        return function () {
            console.log("unsubscribe ");
            counterStore.getSubject().unsubscribe();
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            value,
            " "),
        React.createElement("button", { onClick: function () { return counterStore.increase(); } }, "+ 1"),
        React.createElement("button", { className: "asyncButton", onClick: function () { return counterStore.increaseAsync(); } }, "+ 1 Async")));
};
function App() {
    var _a = useState(false), hide = _a[0], setHide = _a[1];
    var handleButton = function () {
        setHide(!hide);
    };
    return (React.createElement("div", { className: "App" },
        React.createElement("h1", null, "Counter App"),
        React.createElement("div", { className: "action-bar" },
            React.createElement("button", { className: "subscribe-button", onClick: handleButton }, hide ? "Subscribe" : "Unsubscribe")),
        !hide && React.createElement(Counter, null)));
}
export default App;
